module.exports = __webpack_public_path__ + "chart-info.8758ec00f32051c1dc55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chart-info.svg
// module id = ./src/assets/img/chart-info.svg
// module chunks = main